module.exports = __webpack_public_path__ + "img/02h_marketing.710b0cab.jpg";